function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.0304)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("polygon", {
  points: "96.409 28.944 96.409 80.161 79.698 96.89 28.416 96.89 11.703 80.161 11.703 28.944 28.416 12.216 79.698 12.216"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "88.894 32.438 88.894 76.665 76.192 89.381 31.913 89.381 19.214 76.665 19.214 32.438 31.913 19.726 76.192 19.726"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "81.442 36.027 81.442 73.077 72.644 81.851 35.463 81.851 26.663 73.077 26.663 36.027 35.463 27.254 72.644 27.254"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.869,
  x2: 26.663,
  y1: 25.274,
  y2: 36.027
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.848,
  x2: 35.437,
  y1: 4.409,
  y2: 27.214
}), /*#__PURE__*/React.createElement("polygon", {
  points: "104.24 83.812 104.24 25.264 83.261 4.397 24.848 4.397 3.869 25.264 3.869 83.812 24.848 104.68 83.261 104.68"
}), /*#__PURE__*/React.createElement("line", {
  x1: 104.25,
  x2: 81.456,
  y1: 25.274,
  y2: 36.027
}), /*#__PURE__*/React.createElement("line", {
  x1: 83.272,
  x2: 72.682,
  y1: 4.409,
  y2: 27.214
}), /*#__PURE__*/React.createElement("line", {
  x1: 104.25,
  x2: 81.456,
  y1: 83.812,
  y2: 73.06
}), /*#__PURE__*/React.createElement("line", {
  x1: 83.272,
  x2: 72.682,
  y1: 104.68,
  y2: 81.872
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.869,
  x2: 26.663,
  y1: 83.812,
  y2: 73.06
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.848,
  x2: 35.437,
  y1: 104.68,
  y2: 81.872
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(109.9 -.19701)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("polygon", {
  points: "79.698 12.216 96.409 28.944 96.409 80.161 79.698 96.89 28.416 96.89 11.703 80.161 11.703 28.944 28.416 12.216"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "76.192 19.726 88.894 32.438 88.894 76.665 76.192 89.381 31.913 89.381 19.214 76.665 19.214 32.438 31.913 19.726"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "72.644 27.254 81.442 36.027 81.442 73.077 72.644 81.851 35.463 81.851 26.663 73.077 26.663 36.027 35.463 27.254"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.869,
  x2: 26.663,
  y1: 25.274,
  y2: 36.027
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.848,
  x2: 35.437,
  y1: 4.409,
  y2: 27.214
}), /*#__PURE__*/React.createElement("polygon", {
  points: "83.261 104.68 104.24 83.812 104.24 25.264 83.261 4.397 24.848 4.397 3.869 25.264 3.869 83.812 24.848 104.68"
}), /*#__PURE__*/React.createElement("line", {
  x1: 104.25,
  x2: 81.456,
  y1: 25.274,
  y2: 36.027
}), /*#__PURE__*/React.createElement("line", {
  x1: 83.272,
  x2: 72.682,
  y1: 4.409,
  y2: 27.214
}), /*#__PURE__*/React.createElement("line", {
  x1: 104.25,
  x2: 81.456,
  y1: 83.812,
  y2: 73.06
}), /*#__PURE__*/React.createElement("line", {
  x1: 83.272,
  x2: 72.682,
  y1: 104.68,
  y2: 81.872
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.869,
  x2: 26.663,
  y1: 83.812,
  y2: 73.06
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.848,
  x2: 35.437,
  y1: 104.68,
  y2: 81.872
}));

const SvgAscherPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 215,
  height: 107.72,
  enableBackground: "new 0 0 107.715 107.717",
  viewBox: "0 0 215 107.72",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAscherPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ascher-pair.525f0264.svg";
export { ForwardRef as ReactComponent };